import { ApprovalsLeaveRequest } from "../api/LeaveApi";
import { ApprovalsOvertimeRequest } from "../api/OvertimeApi";
import { processScheduleApprovalToken } from "../api/ApprovalActionApi";

export const RunFunction = async (functionName, params) => {
  const actionName = (functionName || "").toLowerCase();

  switch (actionName) {
    case "approvalsleaverequest":
      return await ApprovalsLeaveRequest(params);
    case "approvalsovertimerequest":
      return await ApprovalsOvertimeRequest(params);
    case "approvalsschedulerequest":
      return await processScheduleApprovalToken(params);
    default:
      return {
        status: 400,
        message: "Unknown action for this notification.",
      };
  }
};
